import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/settings/service-keys')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('servicekeys:manage')) {
      throw redirect({ to: '/settings' });
    }
  },
  component: lazyRouteComponent(
    () => import('&/features/settings/service-keys/pages/service-keys-page'),
    'ServiceKeysPage',
  ),
});
